// Shared dismiss behaviour for the inline cmdk comboboxes (UX audit — the
// searchable typeahead pickers that replaced the native <select>s). Closes the
// open dropdown on Escape and on a pointer-down outside the wrapper. Kept as a
// tiny hook so the three pickers (transition-control, player assign-composer,
// attendant open-session counter) don't each re-implement the same listeners.

import { useEffect, type RefObject } from 'react';

export function useComboboxDismiss(
  ref: RefObject<HTMLElement | null>,
  open: boolean,
  onClose: () => void,
): void {
  useEffect(() => {
    if (!open) return;

    const onPointerDown = (e: PointerEvent): void => {
      const el = ref.current;
      if (el && e.target instanceof Node && !el.contains(e.target)) {
        onClose();
      }
    };
    const onKeyDown = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('keydown', onKeyDown, true);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown, true);
      document.removeEventListener('keydown', onKeyDown, true);
    };
  }, [ref, open, onClose]);
}
